import React, { FC, ReactElement, useCallback, useState } from 'react';

import { Link } from 'react-router-dom';

import ArrowBackIos from '@material-ui/icons/ArrowBackIos';

import styles from './styles.module.scss';

import { ConfirmationModal, FormRadioButtons, SubscriptionInfo } from 'components';
import { PlanCard } from './components';

import { plansDetailsList, plansDurations, PLANS_PAGES_INDEXES, subscriptionFaqList } from 'constants/plansItems';

import { IPremiumPlanDetails, ISelectOptions, IPlansInfoProps, ISubscriptionFaq } from 'types/interfaces';
import TurnstileModal from './components/TurnstileModal/TurnstileModal';
import { useHistoryPush } from 'hooks';

export const PlansInfo: FC<IPlansInfoProps> = ({
    formik,
    changePlansPage,
    accountCreated,
    isUpgradingType = false,
    premiumUserData,
}: IPlansInfoProps): ReactElement => {
    const { navigateToPremiumLogin } = useHistoryPush();
    const [confirmationModalOpen, setConfirmationModalOpen] = useState<boolean>(false);
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const changeDuration = useCallback(
        (option: ISelectOptions) => {
            formik.setFieldValue('planInfo.duration', option);
        },
        [formik],
    );

    const onPlanSelect = useCallback(
        (planName: string, title: string, price: number) => {
            formik.setFieldValue('planInfo.planName', planName);
            formik.setFieldValue('planInfo.title', title);
            formik.setFieldValue('planInfo.price', price);
            if (accountCreated) {
                setIsModalOpen(true);
            } else {
                navigateToPremiumLogin();
            }
        },
        [formik, accountCreated, changePlansPage],
    );

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };
    const handleSuccessTurnstile = () => {
        changePlansPage(PLANS_PAGES_INDEXES.PAYMENT);
    };
    return (
        <>
            <div className={styles.container}>
                {isUpgradingType && (
                    <div className={styles.navigationBackBlock}>
                        <Link to="/premium_account_settings" className={styles.accountSettingsLink}>
                            <ArrowBackIos className={styles.arrowIcon} />
                            <span className={styles.text}>Settings</span>
                        </Link>
                    </div>
                )}
                <div className={styles.header}>
                    <div className={styles.textSection}>
                        {isUpgradingType ? (
                            <h1 className={styles.title}>Upgrade your plan</h1>
                        ) : (
                            <>
                                <h1 className={styles.title}>DeepDAO Products - Final Data Sale</h1>
                                <h6 className={styles.description}>
                                    DeepDAO, the #1 discovery and analytics platform for the DAO ecosystem from 2021 to late 2025, is conducting a final data sale for <strong>academic researchers</strong>. Choose your data package from the options below.
                                </h6>
                            </>
                        )}
                    </div>
                </div>

                <div className={styles.plansCardsWrapper}>
                    {plansDetailsList.map((items: IPremiumPlanDetails) => (
                        <PlanCard
                            key={items.id}
                            {...items}
                            duration={formik.values.planInfo.duration}
                            onPlanSelect={onPlanSelect}
                            isUpgradingType={isUpgradingType}
                            userSubscriptions={premiumUserData.userSubscriptions}
                        />
                    ))}
                </div>
            </div>
            {isModalOpen && <TurnstileModal handleClose={handleCloseModal} handleSuccess={handleSuccessTurnstile} />}
            {confirmationModalOpen && (
                <ConfirmationModal
                    onClose={() => setConfirmationModalOpen(false)}
                    confirmationModalOpen={confirmationModalOpen}
                    textInfo={{
                        title: 'You already have a subscription. If you want to switch to another one, please first cancel your existing subscription. To do so go to the Settings page',
                        confirmationText: 'OK',
                    }}
                    onConfirm={() => setConfirmationModalOpen(false)}
                />
            )}
        </>
    );
};
